import { useMemo } from "react";

import { normal } from "color-blend";

import { useTheme } from "../../../context/theme";
import { ACTIVE_OVERLAY_OPACITY, HOVER_OVERLAY_OPACITY } from "../consts";
import {
  baseColorHexToRGBA,
  overlayColorHexToRGBA,
  RGBAToString
} from "../utils";

export default function useStateColor(
  hexColor: string,
  state: "hover" | "active"
) {
  const theme = useTheme();

  const stateColor = useMemo(() => {
    const baseColorRGBA = baseColorHexToRGBA(hexColor);

    const overlayColorRGBA = overlayColorHexToRGBA(
      theme["hover-and-active-overlay"],
      state === "hover" ? HOVER_OVERLAY_OPACITY : ACTIVE_OVERLAY_OPACITY
    );

    const blendRGBA = normal(baseColorRGBA, overlayColorRGBA);

    return RGBAToString(blendRGBA);
  }, [hexColor, theme]);

  return stateColor;
}
